import { Sparkles } from "lucide-react";

export function CoconBadge({ size = "sm", className = "" }) {
  const sm = size === "sm";
  return (
    <span
      data-testid="cocon-badge"
      title="Membre Le Cocoon"
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wider align-middle ${sm ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5"} ${className}`}
      style={{
        color: "hsl(30 45% 12%)",
        WebkitTextFillColor: "hsl(30 45% 12%)",
        background: "linear-gradient(135deg, hsl(45 96% 80%), hsl(35 92% 62%), hsl(28 85% 50%))",
        boxShadow: "0 0 10px hsl(35 90% 60% / 0.4)",
      }}
    >
      <Sparkles size={sm ? 9 : 11} strokeWidth={2.4} /> Le Cocoon
    </span>
  );
}
